import { PPGController } from '../controllers/ppg-controller';
import { PPGService } from './ppg.service';

const services = {
  ppg: new PPGService(PPGController),
};

export { services };
